export interface ICbicVisiters {
  id?: number;
  visiterCount?: number | null;
  visiterCountHi?: number | null;
  visiterCountEn?: number | null;
}

export class CbicVisiters implements ICbicVisiters {
  constructor(public id?: number, public visiterCount?: number | null) {}
}

export function getCbicVisitersIdentifier(cbicVisiters: ICbicVisiters): number | undefined {
  return cbicVisiters.id;
}
